import { ForwardedRef, forwardRef, useEffect, useMemo } from "react";
import TextInput, { ITextInput, TTextInputProps } from "./TextInput";
import Debounce from "../../libs/observer/Debounce";
import { UpdateEvent } from "../GUIEvents";

export type TSearchInputProps = TTextInputProps & {
    delay?: number
    onSearch?:(text:string) => void
}
function SearchInput(props:TSearchInputProps, ref?:ForwardedRef<ITextInput>) {
    const {delay,onUpdate,onSearch,...inputProps} = props
    const debounce = useMemo(() => new Debounce<string>(delay || 250), [])
    const _onUpdate = (e:UpdateEvent) => {
        onUpdate?.(e)
        debounce.next(e.value||"")
    }
    const _onSearch = (text:string) => onSearch?.(text)
    useEffect(() => {
        debounce.subscribe(_onSearch)
        const value = props.defaultValue || props.value
        if (value) debounce.next(value)
        return () => { debounce.unsubscribe(_onSearch) }
    }, [])
    return <TextInput ref={ref} {...inputProps} onUpdate={_onUpdate}/>
}

export default forwardRef(SearchInput)